/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon16Solid = forwardRef('ArrowDim1VIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.503.911a2.125 2.125 0 0 0-3.006 0L3.705 3.704a1.125 1.125 0 0 0 1.59 1.591l1.58-1.579v8.567l-1.58-1.579a1.125 1.125 0 1 0-1.59 1.591l2.792 2.793c.83.83 2.176.83 3.006 0l2.793-2.793a1.125 1.125 0 1 0-1.591-1.59l-1.58 1.58v-8.57l1.58 1.58a1.125 1.125 0 0 0 1.59-1.59L9.504.91Z" })));
});
